'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'house';
var width = 576;
var height = 512;
var aliases = [127968,63498,63500,"home","home-alt","home-lg-alt"];
var unicode = 'f015';
var svgPathData = ['M80.2 268.8l5.8-5.4 202.2-187.8 202.2 187.8 5.8 5.4 0 243.2-144 0 0-176-128 0 0 176-144 0 0-243.2z', 'M310 8.6l-21.8-20.2-21.8 20.2-224 208-23.4 21.8 43.5 46.9 23.4-21.8 202.2-187.8 202.2 187.8 23.4 21.8 43.5-46.9-23.4-21.8-224-208zM352.2 336l-128 0 0 176 128 0 0-176z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouse = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;